import { render, staticRenderFns } from "./GlobalLearningXprizeCoWinner.vue?vue&type=template&id=07718da8&scoped=true&"
import script from "./GlobalLearningXprizeCoWinner.vue?vue&type=script&lang=js&"
export * from "./GlobalLearningXprizeCoWinner.vue?vue&type=script&lang=js&"
import style0 from "./GlobalLearningXprizeCoWinner.vue?vue&type=style&index=0&id=07718da8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07718da8",
  null
  
)

export default component.exports